// cog-spektrix.js

import "./scripts/components/QuantityInput.js";

import "./spektrix-scripts/IFrame.js";
import "./spektrix-scripts/General.js";

import "./spektrix-scripts/pages/AddGiftVoucher.js";
import "./spektrix-scripts/pages/Basket2.js";
import "./spektrix-scripts/pages/ChooseSeats.js";
import "./spektrix-scripts/pages/ChooseAttendee.js";
import "./spektrix-scripts/pages/EditTickets.js";
import "./spektrix-scripts/pages/Multibuypage.js";
import "./spektrix-scripts/pages/MyAccount.js";
import "./spektrix-scripts/pages/SupplementaryEventsPage.js";
import "./spektrix-scripts/pages/Checkout.js";
